export function homeHeroSlick() {

    $('.hero-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
    });

}

export function productSlick() {
    let productSlider = $(".product-slider");
    productSlider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        centerMode: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                }
            }
        ]
    });

    productSlider.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
        const slideCount = slick.slideCount - 1;
        let textBottom = $(this).parents(".scale-slider").find('.textBottom'),
            info = $(this).parents(".scale-slider").find(".info");
        let nextSlideNode;
        if (currentSlide == slideCount && nextSlide == 0) {
            nextSlideNode = $(this).find('.slick-current').next(".item");
        } else if (currentSlide == 0 && nextSlide == slideCount) {
            nextSlideNode = $(this).find('.slick-current').prev(".item");
        } else if (nextSlide - currentSlide > 0) {
            nextSlideNode = $(this).find('.slick-current').next(".item");
        } else {
            nextSlideNode = $(this).find('.slick-current').prev(".item");
        }
        nextSlideNode.addClass("slick-clone-current");
        textBottom.fadeOut(400, function () {
            let button = nextSlideNode.data('button');
            textBottom.find('.textBottom__logo').get(0).src = nextSlideNode.data('logo');
            textBottom.find('.textBottom__text').text(nextSlideNode.data('paragraph'));
            textBottom.find('.btn').text(button.title).get(0).href = button.url;
            textBottom.fadeIn();
        });
        info.fadeOut(400, function () {
            let button = info.find(".btn");
            info.find('.name').text(nextSlideNode.data('name'));
            info.find('.title').text(nextSlideNode.data('title'));
            button.get(0).href = nextSlideNode.data('button-link');
            button.text(nextSlideNode.data('button-title'));
            info.fadeIn();
        });
    });
    productSlider.on('afterChange', function (e, slick, currentSlide, nextSlide) {
        $('.slick-clone-current').removeClass('slick-clone-current');
    })

}

export function postSlider() {

    $('.post-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $('.prev-post'),
        nextArrow: $('.next-post'),
        infinite: false,
        responsive: [
            {
                breakpoint: 1450,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

}

export function logoSlider() {

    $('.logo-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
    });

}

export function recipesSlider() {

    $('.recipes-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        prevArrow: $('.prev-recipe'),
        nextArrow: $('.next-recipe'),
        arrows: true,
        infinite: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1450,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true
                }
            }
        ]
    });
    //slick on beforeChange next content fade out
    $('.recipes-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $(this).find(`[data-slick-index='${nextSlide}']`).find('.content__text').hide();
    });
    $('.recipes-slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $(this).find(`[data-slick-index='${currentSlide}']`).find('.content__text').fadeIn();
    });


}

export function productInfoSlick() {

    $(".product-info-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $('.prev-product-info'),
        nextArrow: $('.next-product-info'),
        centerMode: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1
                }
            },
        ]

    });
}


export function productChangeCurrentItem() {
    $('.product-slider .item').on('click', function () {

        const currentElement = $('.product-slider .slick-current').data("slick-index"),
              clickedElement = $(this).data("slick-index");

        if ( clickedElement ===  currentElement + 1) {
            $('.product-slider').slick('slickNext');
        }
        else if( clickedElement === currentElement - 1) {
            $('.product-slider').slick('slickPrev');
        }
    });
}


export function restaurantSlider() {

	if($('.hns-restaurant__carousel-circle').length)
	{
		$('.hns-restaurant__carousel-circle').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: true,
			prevArrow: $('.prev-dish'),
			nextArrow: $('.next-dish'),
			arrows: true,
			infinite: false,
			centerMode: false,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 981,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 651,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	}
		
	if($('.hns-restaurant__carousel-square').length)
	{
		$('.hns-restaurant__carousel-square').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: true,
			prevArrow: $('.prev-dish'),
			nextArrow: $('.next-dish'),
			arrows: true,
			infinite: false,
			centerMode: false,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 981,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 651,
					settings: {
						slidesToShow: 1
					}
				}
			]
		}).on('setPosition', function (event, slick) {
			slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    	});
	}
	
	$(document).on('click', 'a.hns-btn', function(e) {	
		if($(this).attr('href').indexOf('#') >= 0)
		{
			e.preventDefault();

			let target = this.hash;
		
			target = target.replace('#', '');
			if(target.length)
			{
				if($('#'+target).length)
				{
					let $target = $('#' + target);

					$('html, body').animate({
						'scrollTop': $target.offset().top	
					}, 500);
				}
			}
		}
		
	});    
    
}
